import { normalizeLoyaltyTransactions } from '@utils/storeDataNormalization';
import { storeConstants } from '@utils/constants';
import { mutationTypes } from '@helpers/storeFactories/helpers';
import storeModuleFactory from '@helpers/storeModuleFactory';
import { apiService } from '@api';
import loyaltyTransactionsDetailSection from './loyaltyTransactionsDetailSection';

const STORE_NAME = 'loyaltyTransactions';

const store = storeModuleFactory.createModuleView(
    STORE_NAME,
    {
        get: apiService.loyaltyTransactions.get,
    },
    {
        actionGetOptionsDefault: {
            refresh: false,
            offset: 0,
            limit: storeConstants.ITEMS_PER_PAGE,
        },
        mapListItemFn: normalizeLoyaltyTransactions,
    },
    {
        state: {
            filters: {},
        },
        getters: {
            filters: (state) => state.filters,
            total: (state) => state.totalCount,
        },
        mutations: {
            [mutationTypes.UPDATE_FILTERS](state, { filters }) {
                state.filters = filters;
            },
        },
        actions: {
            async updateFilters({ commit }, { filters }) {
                return commit(mutationTypes.UPDATE_FILTERS, { filters });
            },
        },
        modules: {
            detailSection: loyaltyTransactionsDetailSection,
        },
    }
);

export default store;
